import type { FC } from 'react';
import { Modal, Radio, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { OptimizerClusterView } from '../../types';

export interface ApplyMergeDialogProps {
  open: boolean;
  cluster: OptimizerClusterView | null;
  targetWorkOrderId: string | null;
  loading?: boolean;
  onTargetChange: (workOrderId: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ApplyMergeDialog: FC<ApplyMergeDialogProps> = ({
  open,
  cluster,
  targetWorkOrderId,
  loading = false,
  onTargetChange,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('maintenance');

  return (
    <Modal
      open={open}
      title={t('workOrders.kanban.optimizer.applyTitle')}
      okText={t('workOrders.kanban.optimizer.applyConfirm')}
      cancelText={t('workOrders.kanban.cancel')}
      confirmLoading={loading}
      okButtonProps={{ disabled: !targetWorkOrderId }}
      onCancel={onCancel}
      onOk={onConfirm}
      destroyOnHidden
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <Typography.Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {t('workOrders.kanban.optimizer.applyHint')}
        </Typography.Paragraph>
        <Radio.Group
          value={targetWorkOrderId ?? undefined}
          onChange={(e) => onTargetChange(e.target.value as string)}
          style={{ width: '100%' }}
        >
          <Space direction="vertical">
            {(cluster?.workOrders ?? []).map((wo) => (
              <Radio key={wo.id} value={wo.id}>
                {wo.code} ({wo.status})
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Space>
    </Modal>
  );
};
